import React from "react";
import { useTheme, useMediaQuery } from "@mui/material";
import InnerNavBar from "../../components/InnerNavbar/InnerNavbar";
import Footer from "../../components/Footer/Footer";
import { useTranslation } from "react-i18next";
import { DotLottiePlayer } from '@dotlottie/react-player';


const SuccessJob = () => {
  const { t, i18n } = useTranslation();
  return (
    <section className="successjob">
      <InnerNavBar />{" "}

      <div className="successjob__content">

        <div className="container">
          <div className="successjob__flex-container">
            <div className="successjob-image">


              <DotLottiePlayer
                src="https://lottie.host/86cd6edd-f374-44d8-9c32-1e618ad4dfc1/oIYpBQy6Jm.json"
                autoplay
              />
            </div>
            <div className="content">

              <h6>
               {t("successJobTitle")}

              </h6>
              <p>
                {t("successJobDescription")}
              </p>

            </div>
          </div>



        </div>
      </div>
      <Footer />
    </section>
  );
};

export default SuccessJob;
